module.exports = require("fs");


/*****************
 ** WEBPACK FOOTER
 ** external "fs"
 ** module id = 13
 ** module chunks = 0
 **/